import { IBusinessLocation } from 'models';
import { client } from 'shared';

export async function getEducationOptions(): Promise<string[]> {
    const result = await client('api/location-education-options');
    return result.map((it: { name: string }) => it.name);
}

export interface SaveLocationRequest {
    education_types?: string[];
    name?: string;
    program_id?: string;
    addressData?: {
        street?: string;
        city?: string;
        state?: string;
        zip_code?: string;
    };
}

export async function saveBusinessLocation(id: number | string, req: SaveLocationRequest): Promise<IBusinessLocation> {
    const { addressData, ...businessLocationData } = req;
    return client(`api/business-location/${id}/`, {
        method: 'PATCH',
        body: { ...businessLocationData, ...addressData },
    });
}
